document.addEventListener("DOMContentLoaded", () => {
  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll(".yg-collection-tab-item");
      this.items = this.querySelectorAll(".yg-collection-product-item");
      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 初始化高亮和展示
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle("active", i === 0);
        if (this.items[i]) this.items[i].classList.toggle("active", i === 0);
      });

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener("resize", this.handleResize);

      // 初始化品牌字母点击滚动功能
      this.initBrandLetterScroll();
    }

    initBrandLetterScroll() {
      const brandTop = this.querySelector(".yg-brand-top");
      const brandCollectionsContent = this.querySelector(
        ".yg-brand-collections-content"
      );

      if (!brandTop || !brandCollectionsContent) return;

      const letterButtons = brandTop.querySelectorAll(
        ".yg-brand-letter[data-letter]"
      );

      letterButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const letter = button.getAttribute("data-letter");
          const targetId = `yg-brand-${letter.toLowerCase()}`;
          const targetElement = brandCollectionsContent.querySelector(
            `#${targetId}`
          );

          if (targetElement) {
            // 计算滚动位置，考虑容器顶部偏移
            const containerTop =
              brandCollectionsContent.getBoundingClientRect().top;
            const elementTop = targetElement.getBoundingClientRect().top;
            const scrollTop = brandCollectionsContent.scrollTop;
            const targetScrollTop = scrollTop + elementTop - containerTop;

            brandCollectionsContent.scrollTo({
              top: targetScrollTop,
              behavior: "smooth",
            });
          }
        });
      });
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle("active", index === j));
      this.items.forEach((p, j) => p.classList.toggle("active", index === j));
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = "click";
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = "mouseenter";
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get("yg-mega-menu")) {
    window.customElements.define("yg-mega-menu", YGMegaMenu);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }
});
